export default {
  setUserData: (
    state,
    {
      tokenAccess,
      tokenRefresh,
      email,
      isObipetsAdmin,
      username,
      name,
      phone_number,
      last_name,
      id,
      newuser,
    }
  ) => {
    state.tokenAccess = tokenAccess;
    state.tokenRefresh = tokenRefresh;
    state.email = email;
    state.username = username;
    state.name = name;
    state.phone_number = phone_number;
    state.last_name = last_name;
    state.isObipetsAdmin = isObipetsAdmin;
    state.id = id;
    state.newuser = newuser;
  },
  setTokenAccess: (state, tokenAccess) => {
    state.tokenAccess = tokenAccess;
  },
  clearTokens: (state) => {
    state.tokenAccess = null;
    state.tokenRefresh = null;
  },
  logout: (state) => {
    state.tokenAccess = null;
    state.tokenRefresh = null;
    state.email = null;
    state.username = null;
    state.name = null;
    state.phone_number = null;
    state.last_name = null;
    state.isObipetsAdmin = null;
    state.id = null;
    state.newuser = null;
  },
};
